import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  goalmouth: require("../../../assets/wc/images/goalmouth_transparent.png"),
  goalmouth_field: require("../../../assets/wc/images/goalmouth_field_of.png"),
  background_1920: require("../../../assets/of/videos/background_1920x1080_v2.webm"),
};

export default assets;
